import { css } from 'aphrodite';
import {
	Dialog,
	DialogPopup,
	DialogHeader,
	DialogTitle,
	DialogBody,
	DialogFooter,
} from '../../../components-v2/Dialog';
import { Button } from '../../../components-v2/Button';
import { THEME } from '../../../components-v2/Theme/theme';
import { styleSheet } from './styles/DiscardDialogStyles';

interface DiscardDialogProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isDiscarding: boolean;
}

export function DiscardDialog({ isOpen, onClose, onConfirm, isDiscarding }: DiscardDialogProps) {
	return (
		<Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
			<DialogPopup styles={[styleSheet.popup]}>
				<DialogHeader>
					<DialogTitle>Discard Draft Changes?</DialogTitle>
				</DialogHeader>

				<DialogBody>
					<p className={css(styleSheet.description)}>
						This will discard all unpublished draft changes and restore the last published version. This action cannot
						be undone.
					</p>
					<div className={css(styleSheet.warningBox)}>
						<svg
							width='16'
							height='16'
							viewBox='0 0 16 16'
							fill='none'
							className={css(styleSheet.warningIcon)}
							aria-hidden='true'
						>
							<path
								d='M8 1L15 14H1L8 1Z'
								stroke={THEME.colors.warning.dark}
								strokeWidth='1.5'
								strokeLinecap='round'
								strokeLinejoin='round'
								fill='none'
							/>
							<path d='M8 6v3' stroke={THEME.colors.warning.dark} strokeWidth='1.5' strokeLinecap='round' />
							<circle cx='8' cy='11.5' r='0.75' fill={THEME.colors.warning.dark} />
						</svg>
						<span>Any changes made since the last publish will be permanently lost.</span>
					</div>
				</DialogBody>

				<DialogFooter styles={[styleSheet.actions]}>
					<Button variant='outline' onClick={onClose} disabled={isDiscarding}>
						Cancel
					</Button>
					<Button variant='destructive' onClick={onConfirm} isLoading={isDiscarding}>
						Discard Changes
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
}
